import { Component, Input } from '@angular/core';
import { MenuItemInterface } from '../../interfaces/menu-item.interface';
import { isLastItem } from '../../utils/is-last-item.util';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  @Input() title: string;
  @Input() items: MenuItemInterface[];

  public isLastItem(array: any[], index: number) {
    return isLastItem(array, index);
  }
}
